import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/deal-packets/presets")({
  staticData: {
    breadcrumb: "Presets",
  },
  component: PresetsLayout,
})

function PresetsLayout() {
  return <Outlet />
}
